import React from 'react';
import {connect} from 'react-redux';

const AiYearLogo = ({showAiYearLogo, style, className, noTopMargin}) => {
	if (!showAiYearLogo) {
		return null;
	}

	return (
			<img
					className={[noTopMargin ? null : 'mt-2', className].filter(Boolean).join(' ')}
					src={`${process.env.PUBLIC_URL}/ai-year.svg`}
					alt={'ai-year'}
					style={{...style, width: '110px'}}
			/>
	);
};

function mapStateToProps(state) {
	return {
		showAiYearLogo: state.imageReducer.showAiYearLogo,
	};
}

export default connect(mapStateToProps)(AiYearLogo);
